import mutations from "./mutations";
import queries from "./queries";

export default {
  mutations,
  queries,
};
